import { useEffect, useState } from 'react';
import { players } from './api';
import { useSync } from './Lobby';
import { track } from '../../lib/telemetry';

/** Großer Hinweis mit Partie-Code zum Teilen. Zeigt, ob der Mitspieler schon beigetreten ist. */
export function InviteBanner() {
  const sync = useSync();
  const [n, setN] = useState<number | null>(null);
  const [copied, setCopied] = useState<string | null>(null);
  const id = sync?.match.id;
  useEffect(() => {
    if (!id) return;
    let alive = true;
    const load = () => { players(id).then((p) => { if (alive) setN(p.length); }).catch(() => {}); };
    load();
    const t = setInterval(load, 4000);
    return () => { alive = false; clearInterval(t); };
  }, [id]);
  if (!sync) return null;
  return <InviteCard code={sync.match.code} n={n} copied={copied} setCopied={setCopied} />;
}

/** Darstellung ohne Serververbindung (auch für Tests). */
export function InviteCard({ code, n, copied = null, setCopied = () => {} }: { code: string; n: number | null; copied?: string | null; setCopied?: (x: string | null) => void }) {
  const joined = (n ?? 0) >= 2;
  const link = typeof location !== 'undefined' ? `${location.origin}/mitspielen?code=${code}` : `/mitspielen?code=${code}`;
  const copy = async (txt: string, what: string) => {
    try { await navigator.clipboard.writeText(txt); setCopied(what); track('Multiplayer.inviteCopied', { what }); setTimeout(() => setCopied(null), 1800); } catch { setCopied('fail'); }
  };
  return (
    <div className={'invite' + (joined ? ' ok' : '')} role="status">
      <div className="inv-l">
        <span className="label">{joined ? 'Mitspieler ist dabei' : 'Code an deinen Mitspieler schicken'}</span>
        <b className="inv-code num" aria-label={`Partie-Code ${code.split('').join(' ')}`}>{code}</b>
        <span className="sub">{joined ? 'Beide sind in der Partie. Ihr könnt eure Parteien gründen.' : 'Unter „Mitspielen“ gibt dein Mitspieler diesen Code ein, oder er öffnet einfach den Link.'}</span>
      </div>
      <div className="inv-r">
        {!joined && <><button type="button" className="yes" onClick={() => copy(code, 'code')}>{copied === 'code' ? 'Kopiert ✓' : 'Code kopieren'}</button>
        <button type="button" onClick={() => copy(link, 'link')}>{copied === 'link' ? 'Link kopiert ✓' : 'Link kopieren'}</button></>}
        {copied === 'fail' && <span className="sub down">Kopieren nicht möglich, bitte abschreiben.</span>}
        <span className={'inv-st ' + (joined ? 'up' : 'warn')}>{n == null ? '…' : joined ? '● 2 von 2 Spielern' : '○ Warte auf Mitspieler …'}</span>
      </div>
    </div>
  );
}
